var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "active": _vm.active,
      "message": _vm.message
    },
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29347344","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/notification/Notification/Notification.vue
// module id = 1218
// module chunks = 0